import React from 'react';
import { Box, Typography, Stack, IconButton } from '@mui/material';
import {
    Recycling, Facebook, Twitter, Instagram, LinkedIn, GitHub, YouTube
} from '@mui/icons-material';

const BrandSection = () => {
    const socialLinks = [
        { icon: <Facebook />, href: '#' },
        { icon: <Twitter />, href: '#' },
        { icon: <Instagram />, href: '#' },
        { icon: <LinkedIn />, href: '#' },
        { icon: <GitHub />, href: '#' },
        { icon: <YouTube />, href: '#' }
    ];

    return (
        <Box>
            {/* Logo and Brand Name */}
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <Recycling sx={{ mr: 1.5, fontSize: 32, color: '#66bb6a' }} />
                <Typography variant="h4" fontWeight={800} sx={{
                    background: 'linear-gradient(45deg, #66bb6a, #43a047)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent'
                }}>
                    Sortify
                </Typography>
            </Box>

            {/* Brand Description */}
            <Typography variant="body1" sx={{ mb: 3, opacity: 0.9, lineHeight: 1.7 }}>
                🌍 Revolutionizing waste management in Bangladesh through AI-powered classification.
                Join thousands of eco-warriors making our planet cleaner, one classification at a time.
            </Typography>

            {/* Mission Statement */}
            <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle2" gutterBottom fontWeight={600}>
                    🎯 Our Mission
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.8 }}>
                    Building a sustainable future by empowering citizens with intelligent waste sorting technology.
                </Typography>
            </Box>

            {/* Social Media Links */}
            <Stack direction="row" spacing={1} flexWrap="wrap">
                {socialLinks.map((social, index) => (
                    <IconButton
                        key={index}
                        size="small"
                        href={social.href}
                        sx={{
                            color: '#66bb6a',
                            background: 'rgba(102, 187, 106, 0.1)',
                            '&:hover': {
                                background: 'rgba(102, 187, 106, 0.2)',
                                transform: 'translateY(-2px)'
                            },
                            transition: 'all 0.3s ease'
                        }}
                    >
                        {social.icon}
                    </IconButton>
                ))}
            </Stack>
        </Box>
    );
};

export default BrandSection;
